import { render, staticRenderFns } from "./jiugongge.vue?vue&type=template&id=92e644cc&scoped=true&"
import script from "./jiugongge.vue?vue&type=script&lang=js&"
export * from "./jiugongge.vue?vue&type=script&lang=js&"
import style0 from "./jiugongge.vue?vue&type=style&index=0&id=92e644cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e644cc",
  null
  
)

export default component.exports